import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Creatable from "react-select/lib/Creatable";
import { useSelector, useDispatch } from "react-redux";
import { buildOptions } from "../utils";
import { uniq } from "lodash";
import useFetch from "../fetch";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

function CriminalHistoryFormModal() {
  const props = useSelector((state) => {
    return {
      show: state.ui.criminalHistoryModal.show,
      criminalHistory:
        state.criminalHistory || state.ui.criminalHistoryModal.criminalHistory,
      organizationName: state.organization.name,
      resident: state.resident,
      isStaffApp: state.config.isStaffApp,
    };
  });
  const dispatch = useDispatch();
  const fetch = useFetch();
  const closeModal = () =>
    dispatch({
      type: "CLOSE_RESOURCE_MODAL",
      payload: { resourceName: "criminalHistory" },
    });
  const updateField = (name, value) =>
    dispatch({
      type: "UPDATE_RESOURCE_FIELD",
      payload: { resourceName: "criminalHistory", name, value },
    });

  const setDefaultStaffAppMetaData = () =>
    sendStaffAppMetaData(props.criminalHistoryTabDefaultMetaData);

  const updateResidentCriminalHistoryAction = () => {
    return (dispatch, getState) => {
      const state = getState();
      return fetch(
        `/organizations/${state.organization.name}/residents/${state.resident.id}/criminal_history.json`,
        {
          method: "PATCH",
          data: {
            criminal_history: state.ui.criminalHistoryModal.criminalHistory,
          },
        }
      ).then((data) => {
        dispatch({
          type: "UPDATE_CRIMINAL_HISTORY",
          payload: { criminalHistory: data.criminal_history },
        });
      });
    };
  };

  const updateCriminalHistory = () => {
    dispatch(updateResidentCriminalHistoryAction()).then((data) => {
      if (props.isStaffApp) alert("Criminal History changes saved.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const {
    involved_with_criminal_system,
  } = props.criminalHistory;
  const options = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  const involvedWithCriminalSystemValue = options.find(
    (option) => option.value === involved_with_criminal_system
  );

  return (
    <Modal
      animation={!props.isStaffApp}
      show={props.show}
      onHide={() => closeModal()}
    >
      {!props.isStaffApp && (
        <Modal.Header closeButton>
          <Modal.Title>Criminal History</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className="p-4">
        <Form.Group controlId="criminalHistoryOther">
          <Form.Label>
            Are you currently involved with the criminal justice system
          </Form.Label>
          <Creatable
            options={options}
            value={involvedWithCriminalSystemValue}
            onChange={(option) => {
              updateField("involved_with_criminal_system", option.value);
            }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="info" onClick={() => updateCriminalHistory()}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CriminalHistoryFormModal;
